import { authorizedGetRequest, authorizedPutRequest } from "./httpClient";

// Client-Alert-Tickets config API surface, scoped by PracticeId the same way
// orgPageAccessApi.js is - every call takes practiceId explicitly, so the only thing this
// needs from the provider is the logged-in user (for user.token). The GET response never
// includes WebhookAuthSecret (write-only server-side); this module never reads, stores, or
// logs it either - it only ever forwards it inside a saveClientAlertConfig request body.
export const createClientAlertConfigApi = ({ user }) => {
  const getClientAlertConfig = async (practiceId) => {
    const resolvedPracticeId = Number.parseInt(practiceId, 10);
    if (!resolvedPracticeId) {
      throw new Error("PracticeId is required");
    }

    const response = await authorizedGetRequest(
      user.token,
      `/api/PracticeClientAlertConfig/${resolvedPracticeId}`,
    );

    return response?.config || null;
  };

  const saveClientAlertConfig = async (practiceId, config) => {
    const resolvedPracticeId = Number.parseInt(practiceId, 10);
    if (!resolvedPracticeId) {
      throw new Error("PracticeId is required");
    }

    const response = await authorizedPutRequest(
      user.token,
      `/api/PracticeClientAlertConfig/${resolvedPracticeId}`,
      config || {},
    );

    return response?.config || null;
  };

  return { getClientAlertConfig, saveClientAlertConfig };
};
